import { render, staticRenderFns } from "./job-column.vue?vue&type=template&id=2dd54672&scoped=true&"
import script from "./job-column.vue?vue&type=script&lang=js&"
export * from "./job-column.vue?vue&type=script&lang=js&"
import style0 from "./job-column.vue?vue&type=style&index=0&id=2dd54672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd54672",
  null
  
)

export default component.exports